import { DatePipe } from '@angular/common';
import { Component, Input, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { consentValidator, phoneNumberValidator, insValidator } from 'src/app/directives/patient-validator.directive';
import { City } from 'src/app/interfaces/city';
import { Directory } from 'src/app/interfaces/directory';
import { DirectoryService } from 'src/app/services/api/directory.service';
import { LocalisationService } from 'src/app/services/localisation.service';

@Component({
  selector: 'app-patient-info-edit',
  templateUrl: './patient-info-edit.component.html',
  styleUrls: ['./patient-info-edit.component.scss'],
  providers: [DatePipe]
})
export class PatientInfoEditComponent implements OnInit {

    @Input() patient!: Directory;

    public errorMessage: string = '';
    public errorType: string = '';

    public patientForm: FormGroup | undefined;

    cities: City[] = [];

    filteredOptions: Observable<City[]> | undefined;
    closeResult = '';

    maxDate = new Date();

    selectedCity: string = '';

    constructor(public activeModal: NgbActiveModal,
                public directoryService: DirectoryService,
                private datePipe: DatePipe,
                private localisationService: LocalisationService) { }

    ngOnInit(): void {
        this.patientForm = new FormGroup({
            lname: new FormControl(this.patient?.lname, [Validators.required, Validators.pattern("^[a-zA-ZÀ-ÿ' -]+$")]),
            fname: new FormControl(this.patient?.fname, [Validators.required,Validators.pattern("^[a-zA-ZÀ-ÿ' -]+$")]),
            email: new FormControl(this.patient?.user?.email, [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
            phoneNumber: new FormControl(this.patient?.phoneNumber, [Validators.required, phoneNumberValidator()]),
            city: new FormControl(this.patient?.city, Validators.pattern("^[a-zA-ZÀ-ÿ' -]+$")),
            consent: new FormControl(this.patient?.consent, [Validators.required, consentValidator()]),
            ins: new FormControl(this.patient?.ins, [Validators.required, insValidator()]),
        });

        if (this.patient?.dateOfBirth) {
            var from = this.patient?.dateOfBirth.split("/");
            this.patientForm.addControl('dateOfBirth', new FormControl(new Date(parseInt(from[2],10), parseInt(from[1]) - 1, parseInt(from[0]))));
        } else {
            this.patientForm.addControl('dateOfBirth', new FormControl(''));
        }

        this.filteredOptions = this.patientForm.controls.city.valueChanges.pipe(
            startWith(''),
            debounceTime(500),
            distinctUntilChanged(),
            map((value) => value && value.length >= 1 ? this._filter(value) : [])
        );
    }

    private _filter(value: string): City[] {
        this.cities = [];
        if (value.length >= 3) {
            const filterValue = value.toLowerCase();
            if (filterValue.match(/\d{5}/gm)) {
                if (filterValue == '98000') {
                    var monaco = <City>{};
                    monaco.nom = 'Monaco';
                    this.cities.push(monaco);
                    return this.cities;
                } else {
                    this.localisationService.getCitiesByPostalCode(filterValue).subscribe((res) => {
                        res.forEach((cityRes) => {
                            var city = <City>{};
                            city.nom = cityRes.nom;
                            this.cities.push(city);
                        });

                        return this.cities;
                    });
                }
            } else {
                if (filterValue.match(/monaco/gm)) {
                    var monaco = <City>{};
                    monaco.nom = 'Monaco';
                    this.cities.push(monaco);
                    return this.cities;
                } else {
                    this.localisationService.getCities(filterValue).subscribe((res) => {
                        res.forEach((cityRes) => {
                            var city = <City>{};
                            city.nom = cityRes.nom;
                            this.cities.push(city);
                        });
                        return this.cities;
                    });
                }
            }
        } else {
            this.cities = [];
        }
        return this.cities;
    }

    editPatient(patient: Directory) {
        if (patient.dateOfBirth != '') {
            patient.dateOfBirth = this.datePipe.transform(patient.dateOfBirth, 'yyyy-MM-dd');
        } else {
            patient.dateOfBirth = this.datePipe.transform('', 'yyyy-MM-dd');
        }

        patient.consentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

        this.directoryService.updatePatient(patient).subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.errorMessage = res.content;
                this.errorType = res.result;
                this.updatePatient(patient);
                this.activeModal.dismiss(this.patient);
            } else {
                this.errorMessage = res.content;
                this.errorType = res.result;
            }
        });
    }

    private updatePatient(patient: any)
    {

        if (this.patient.lname != patient.lname) {
            this.patient.lname = patient.lname;
        }

        if (this.patient.fname != patient.fname) {
            this.patient.fname = patient.fname;
        }

        if (this.patient.phoneNumber != patient.phoneNumber) {
            this.patient.phoneNumber = patient.phoneNumber;
        }

        if (this.patient.dateOfBirth != patient.dateOfBirth) {
            this.patient.dateOfBirth = patient.dateOfBirth;
        }

        if (this.patient.ins != patient.ins) {
            this.patient.ins = patient.ins;
        }
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.patientForm?.controls[controlName].hasError(errorName);
    }

    cityClick(event: any) {
        this.selectedCity = event.option.value;
    }

    checkCity() {
        setTimeout(()=> {
            if (!this.selectedCity || this.selectedCity !== this.patientForm?.controls['city'].value) {
                if (this.patientForm?.controls['city'].value.match(/\d{5}/gm)) {
                    this.patientForm?.controls['city'].setValue(null);
                    this.selectedCity = '';
                }
            }
        }, 500);
    }
}
